export default {
  category: 'book',
  name: 'The Ultimate Anabolic Cookbook',
  author: 'Greg Doucette',
  date: '6/14/20',
  path: '/notes/the-ultimate-anabolic-cookbook',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-the-ultimate-anabolic-cookbook-greg-doucette.jpg',
  tags: ['Diet', 'Cooking', 'Health'],
  time: 1,
  rating: 7.5,
  review: '',
  link: 'https://www.gregdoucette.com/cookbook',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
twosLink: '',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: ''
};
